import { useEffect, useState } from "react";

import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import { HttpMethodProps } from "../../types";
import { HttpCodes } from "../data";

interface RequestOptions {
  method: HttpMethodProps;
  route: string;
  data?: any;

  doNotUseAuthorization?: boolean;
}
export function usePerformRequest<Type>({
  method,
  route,
  data: body,

  doNotUseAuthorization = false,
}: RequestOptions) {
  const [data, setData] = useState<Type>();
  const [response, setResponse] = useState<AxiosResponse>();
  const [error, setError] = useState<AxiosError>();
  const [status, setStatus] = useState<number | string>("undefined");
  const [isLoading, setLoading] = useState<boolean>(false);
  const reloadData = async () => {
    const token = localStorage.getItem("t");
    const headers: any = {};
    if (!doNotUseAuthorization && token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const config: AxiosRequestConfig = {
      headers,
      method,
      data: body,
      url: route,
    };
    setLoading(true);
    const r: any = await axios
      .request(config)
      .catch((e: AxiosError<Type, Type>) => {
        setError(e);
        setStatus(e.response?.status as number);

        return {
          status: e.response?.status,
        };
      });
    setResponse(r as AxiosResponse);
    setStatus(r.status);
    setLoading(false);
    setData(r?.data ?? undefined);
  };
  useEffect(() => {
    reloadData().catch(() => setLoading(false));
  }, [route]);

  return { data, response, isLoading, reloadData, status, error };
}

interface PerformRequestOptions {
  method: HttpMethodProps;
  data?: any;
  route: string;
  headers?: any;
  doNotUseAuthorization?: boolean;
  onError?: () => any;
}

export async function PerformRequest<Type>({
  method,
  data,
  route,
  headers,
  doNotUseAuthorization,
  onError,
}: PerformRequestOptions) {
  const token = localStorage.getItem("t");

  // Prepare headers - if data is FormData, let axios set Content-Type automatically
  let requestHeaders: any;
  if (doNotUseAuthorization) {
    requestHeaders = { ...headers };
  } else {
    requestHeaders = { Authorization: `Bearer ${token}`, ...headers };
  }

  // If data is FormData, remove Content-Type from headers to let axios set it automatically with boundary
  if (data instanceof FormData && requestHeaders["Content-Type"]) {
    delete requestHeaders["Content-Type"];
  }

  const config = {
    method,
    data,
    url: route,
    headers: requestHeaders,
  };

  const r: any = await axios.request(config).catch((e: AxiosError) => {
    if (onError) onError();
    return {
      status: e.response?.status,
      message: (e?.response?.data as any)?.message,
      data: (e?.response?.data as any)?.data,
    };
  });
  if (r.status === HttpCodes.Forbidden) {
  }
  return {
    status: r.status as number,
    data: r as Type,
    message: r?.message ?? undefined,
  };
}
